export default __webpack_public_path__ + "static/media/home-logo.dfa39033.svg";